<section class="leads-page">
  <div class="leads-toolbar">
    <div class="leads-filters">
      <label class="cg-admin-field leads-filters__field">
        <span class="cg-admin-field__label">Search</span>
        <input
          class="cg-input"
          type="search"
          [(ngModel)]="searchInput"
          (ngModelChange)="onSearchChange()"
          name="search"
          placeholder="Name, email, phone"
        />
      </label>
      <app-crm-list-filters-dropdown
        [assignedToValue]="ownerUserId"
        [statusValue]="statusId"
        [destinationValue]="preferredDestination"
        [assignedToOptions]="assignedToFilterOptions()"
        [statusOptions]="statusFilterOptions()"
        [destinationOptions]="destinationFilterOptions()"
        (assignedToChange)="onAssignedToFilterChange($event)"
        (statusChange)="onStatusFilterChange($event)"
        (destinationChange)="onDestinationFilterChange($event)"
        (cleared)="onFiltersClear()"
      />
      <label class="cg-admin-field leads-filters__field">
        <span class="cg-admin-field__label">Stream</span>
        <select class="cg-select" [(ngModel)]="streamFilter" (ngModelChange)="onFilterChange()" name="stream">
          <option value="">All</option>
          @for (s of streamOptions; track s) {
            <option [value]="s">{{ s }}</option>
          }
        </select>
      </label>
      <label class="cg-admin-field leads-filters__field leads-filters__field--date">
        <span class="cg-admin-field__label">From</span>
        <input class="cg-input" type="date" [(ngModel)]="createdFrom" (ngModelChange)="onFilterChange()" name="from" />
      </label>
      <label class="cg-admin-field leads-filters__field leads-filters__field--date">
        <span class="cg-admin-field__label">To</span>
        <input class="cg-input" type="date" [(ngModel)]="createdTo" (ngModelChange)="onFilterChange()" name="to" />
      </label>
    </div>

    <div class="leads-toolbar__actions">
      <div class="leads-toolbar__buttons">
        @if (showImport()) {
          <app-admin-button variant="primary" type="button" (click)="openImport()" [disabled]="!canImport()">
            Import Leads
          </app-admin-button>
        }
        @if (showExport()) {
          <app-admin-button variant="secondary" type="button" [disabled]="!canExport() || loading() || exporting()" (click)="exportLeads()">
            {{ exporting() ? 'Exporting…' : 'Export' }}
          </app-admin-button>
        }
        @if (showRemoveDuplicates()) {
          <app-admin-button variant="secondary" type="button" [disabled]="!canRemoveDuplicates() || loading()" (click)="openDuplicates()">
            Remove Duplicates
          </app-admin-button>
        }
        @if (showCreate()) {
          <app-admin-button variant="primary" type="button" (click)="openCreate()" [disabled]="!canCreate()">
            Create Lead
          </app-admin-button>
        }
      </div>
      <div class="leads-toolbar__toggles">
        <label class="leads-toolbar__archive">
          <input
            type="checkbox"
            [ngModel]="ownerUserId === 'me'"
            (ngModelChange)="onAssignedToMeToggle($event)"
            name="assignedToMe"
          />
          Show leads assigned to me
        </label>
        <label class="leads-toolbar__archive">
          <input type="checkbox" [(ngModel)]="showArchived" (ngModelChange)="onFilterChange()" name="showArchived" />
          Show archived
        </label>
        <label class="leads-toolbar__archive">
          <input
            type="checkbox"
            [(ngModel)]="showEnrolled"
            (ngModelChange)="onFilterChange()"
            name="showEnrolled"
          />
          Show Enrolled Leads
        </label>
        <label class="leads-toolbar__archive">
          <input
            type="checkbox"
            [(ngModel)]="showDisqualified"
            (ngModelChange)="onFilterChange()"
            name="showDisqualified"
          />
          Show Disqualified Leads
        </label>
      </div>
    </div>
  </div>

  <app-admin-table>
    <thead>
      <tr>
        <th>Name</th>
        <th>Contact</th>
        <th>Preferred destination</th>
        <th>Assigned to</th>
        <th>Created</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      @if (loading()) {
        <tr>
          <td colspan="6"><p class="cg-form-help">Loading leads…</p></td>
        </tr>
      } @else if (leads().length === 0) {
        <tr>
          <td colspan="6">
            <app-admin-empty-state icon="users" title="No leads" description="Leads from consultation forms will appear here." />
          </td>
        </tr>
      } @else {
        @for (lead of leads(); track lead._id) {
          <tr [class.leads-row--archived]="lead.isArchived">
            <td>
              <a class="cg-admin-link" [routerLink]="['/platform/leads', lead._id]"><strong>{{ lead.fullName }}</strong></a>
              @if (lead.subStatus?.name; as subStatusName) {
                <div class="leads-name-substatus"><strong>{{ subStatusName }}</strong></div>
              }
              @if (lead.latestNote || lead.message; as notePreview) {
                <app-lead-message-preview
                  [message]="notePreview"
                  [modalTitle]="'Note — ' + lead.fullName"
                />
              }
            </td>
            <td>
              <div>{{ lead.email }}</div>
              <div class="cg-form-help">{{ lead.phoneNumber }}</div>
            </td>
            <td><code class="cg-input--mono">{{ lead.preferredDestination || '—' }}</code></td>
            <td>{{ lead.owner?.displayName || '—' }}</td>
            <td>{{ lead.createdAt | date: 'medium' }}</td>
            <td>{{ lead.status.name }}</td>
          </tr>
        }
      }
    </tbody>
  </app-admin-table>

  @if (!loading()) {
    <div class="leads-pagination">
      <span class="cg-form-help">{{ pageSummary() }}</span>
      <div class="leads-pagination__actions">
        <label class="leads-pagination__page-size">
          <span class="cg-form-help">Rows</span>
          <select class="cg-select" [(ngModel)]="pageSize" (ngModelChange)="onFilterChange()" name="pageSize">
            @for (n of pageSizeOptions; track n) {
              <option [value]="n">{{ n }}</option>
            }
          </select>
        </label>
        <app-admin-button variant="secondary" type="button" [disabled]="page() <= 1 || loading()" (click)="goToPage(page() - 1)">
          Previous
        </app-admin-button>
        <app-admin-button variant="secondary" type="button" [disabled]="!hasNextPage() || loading()" (click)="goToPage(page() + 1)">
          Next
        </app-admin-button>
      </div>
    </div>
  }
</section>

@if (createOpen()) {
<app-admin-side-panel
  title="Create Lead"
  (closed)="closeCreate()"
>
  <form class="leads-create-form" (ngSubmit)="submitCreate()">
    <div class="leads-create-form__photo">
      <app-lead-profile-avatar
        [photoUrl]="photoPreviewUrl() ?? undefined"
        [fullName]="createForm.fullName"
        [uploading]="photoUploading()"
        [showRemoveLink]="!!photoPreviewUrl()"
        hint="Passport photo · 3″ × 4″ · max 5 MB"
        (photoSelected)="onCreatePhotoSelected($event)"
        (removePhoto)="removeCreatePhoto()"
      />
    </div>

    <app-lead-form-fields
      [form]="createForm"
      [fieldErrors]="createFieldErrors()"
      [destinationOptions]="destinationOptions()"
      [stateOptions]="stateOptions()"
      [passportStatusOptions]="passportStatusOptionList()"
    />

    @if (createError()) {
      <p class="cg-form-help cg-form-help--error" role="alert">{{ createError() }}</p>
    }
    <div class="leads-create-form__actions">
      <app-admin-button variant="secondary" type="button" [disabled]="createSaving()" (click)="closeCreate()">
        Cancel
      </app-admin-button>
      <app-admin-button variant="primary" type="submit" [disabled]="createSaving() || photoUploading()">
        {{ createSaving() || photoUploading() ? 'Creating…' : 'Create Lead' }}
      </app-admin-button>
    </div>
  </form>
</app-admin-side-panel>
}

@if (importOpen()) {
  <app-lead-import-modal
    area="platform"
    (closed)="closeImport()"
    (importCompleted)="onImportCompleted()"
  />
}

@if (duplicatesOpen()) {
  <app-lead-duplicates-modal
    area="platform"
    (closed)="closeDuplicates()"
    (removed)="onDuplicatesRemoved()"
    (mergeRequested)="openMerge($event)"
  />
}

@if (showMerge() && mergeOpen() && mergeLeadIds().length >= 2) {
  <app-lead-merge-modal
    area="platform"
    [leadIds]="mergeLeadIds()"
    (closed)="closeMerge()"
    (merged)="onMerged()"
  />
}
